import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  // Route,Switch
} from 'react-router-dom';
import './App.scss';
import './style/customstyle.css';
import RouteMap from './route';
import { createBrowserHistory } from 'history';


function getFaviconEl() {
  return document.getElementById("favicon");
}
function getAppFavicon(){
  return document.getElementById("fav");
}
function getAppTitle(){
  return document.getElementById('companyname')
}
export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logo: '',
      title:''
    }
  }
 
  componentDidMount() {
    fetch(
      // "https://demo4.infinitemlmdemo.com/david_jarman/backoffice/api/common/app_info", {
      "http://demo8.infinitemlmdemo.com/david_jarman/backoffice/api/common/app_info", {
      // "https://shop.lifetimequote.com/backoffice/api/common/app_info", {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'api-key': '2a6bf5ed-178e-4d2f-800c-76022261530b'
      },
    })
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          logo: json.data.company_info.favicon,
          title:json.data.company_info.company_name 
        });
        this.handleGoogle();
      })
  }

  handleGoogle() {
    const favicon = getFaviconEl(); // Accessing favicon element
    const fav = getAppFavicon();
    // favicon.href = "https://demo4.infinitemlmdemo.com/david_jarman/uploads/images/logos/" + this.state.logo;
    // fav.href = "https://demo4.infinitemlmdemo.com/david_jarman/uploads/images/logos/" + this.state.logo;
    favicon.href = "http://demo8.infinitemlmdemo.com/david_jarman/uploads/images/logos/" + this.state.logo;
    fav.href = "http://demo8.infinitemlmdemo.com/david_jarman/uploads/images/logos/" + this.state.logo;
    // favicon.href = "https://shop.lifetimequote.com/uploads/images/logos/" + this.state.logo;
    // fav.href = "https://shop.lifetimequote.com/uploads/images/logos/" + this.state.logo;
  };


  handleApptitle(){
    getAppTitle()
    document.title=this.state.title;

  }
  render() {
    return (
      <Router>
        <RouteMap />
      </Router>
    )
  }
}
export default App;
